import React, { useState } from 'react'
import Container from '../../layout/container'
import { MosaicStyle, ItemMosaic, ColumnGroup, ColumnA, ColumnB } from './style'

import Img1 from '../../assets/mosaic/img1.jpeg';
import Img2 from '../../assets/mosaic/img2.jpeg';
import Img3 from '../../assets/mosaic/img3.png';
import Img4 from '../../assets/mosaic/img4.jpeg';
import Img5 from '../../assets/mosaic/img5.jpeg';
import Img6 from '../../assets/mosaic/img6.jpeg';

const column1 = [
  {
    id: 1,
    title: 'Cuidado corporal',
    text: 'Nativa SPA, línea con altas propiedades de hidratación y fragancias derivadas de activos vegetales.',
    img: Img1
  },
  {
    id: 2,
    title: 'Infantil',
    text: 'La línea joven y divertida para los más pequeños de la familia pensada con suaves fragancias y fórmulas que cuiden su delicada piel.',
    img: Img2
  },
  {
    id: 3,
    title: 'Maquillaje',
    text: 'Make B, línea  con colores, texturas y fórmulas innovadoras que siguen las tendencias de belleza en el mundo.',
    img: Img3
  }
]

const column2 = [
  {
    id: 4,
    title: 'Perfumería femenina',
    text: 'Variedad de fragancias con un proceso de alquimia única que refuerzan los atributos de cada mujer.',
    img: Img4
  },
  {
    id: 5,
    title: 'Cuidado capilar',
    text: 'Match pensado en las necesidades de cuidado que tiene cada cabello y para cada necesidad existe un match.',
    img: Img5
  },
  {
    id: 6,
    title: 'Perfumería masculina',
    text: 'Combinaciones e ingredientes que capturan la atención y conquistan los sentidos de cualquiera con su deliciosa fragancia.',
    img: Img6
  }
]

export default function Mosaic() {
  const [active, setActive] = useState(0);

  return (
    <MosaicStyle id="productos">
      <Container>
        <h2>Nuestros <span>Productos</span></h2>
      </Container>

      <ColumnGroup>
        <ColumnA>
          {column1.map(({ id, title, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              text={text}
              img={img}
              isActive={active === id}
              onItemClicked={() => setActive(id)}
            />
          )}
        </ColumnA>

        <ColumnB>
          {column2.map(({ id, title, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              text={text}
              img={img}
              isActive={active === id}
              onItemClicked={() => setActive(id)}
            />
          )}
        </ColumnB>
      </ColumnGroup>
    </MosaicStyle>
  )
}

const Item = ({ id, title, text, img, isActive = false, onItemClicked = () => console.error('You passed no action to the component') }) => {
  return (
    <ItemMosaic id={id} className={`item-${id} ${isActive ? 'active' : ''}`} onClick={onItemClicked} style={{ backgroundImage: `url(${img})` }}>
      <span>{title}</span>

      <div>
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </ItemMosaic>
  )
}